import React, { useState, useRef, useEffect, useCallback } from "react";
// components
import { ISelectProps } from "../../../interfaces/inputs";
import Header from "./Header";
import List from "./List";
import { SelectContainer } from "./SelectStyles";
// utils
import { ListItem } from "../../common/useFilters";
import { closeOnBlur } from "../../../utils/closeOnBlur";
import dropdownArrowBlack from "../../../assets/icons/dropdownArrowBlack.svg";
import { useTranslation } from "react-i18next";

const Select: React.FC<ISelectProps> = ({
  keyName,
  title,
  list,
  toggleItem,
  removeAllSelected,
  isFilterActive,
  guestTitle,
  hasFilterInput = false,
}) => {
  const [listOpen, setListOpen] = useState(false);
  const [filteredList, setFilteredList] = useState(list);
  const wrapperRef = useRef(null);
  const { t } = useTranslation();

  const toggleList = () => setListOpen(!listOpen);
  const selectedItems: ListItem[] =
    list && list.filter((item: ListItem) => item.selected);

  const iconProps = {
    rotate: 1,
    src: dropdownArrowBlack,
    alt: "dropdown arrow",
  };

  useEffect(() => {
    closeOnBlur(wrapperRef, setListOpen);

    const sortedList = list.sort((a, b) => (a.title > b.title ? 1 : -1));
    setFilteredList(sortedList);
  }, [list]);

  const onListFilter = useCallback(
    (value: string) => {
      setFilteredList(
        list.filter((item) =>
          item.title.toLowerCase().includes(value.toLowerCase())
        )
      );
    },
    [list]
  );

  return (
    <SelectContainer>
      <div ref={wrapperRef}>
        <Header
          initFilterList={() => setFilteredList(list)}
          onListFilter={onListFilter}
          hasFilterInput={hasFilterInput}
          guestTitle={guestTitle}
          title={t(title)}
          listOpen={listOpen}
          onClick={toggleList}
          isFilterActive={isFilterActive}
          iconProps={iconProps}
          keyName={keyName}
          selectedItemsCount={selectedItems.length && selectedItems.length}
        />
        {listOpen && (
          <List
            list={filteredList}
            toggleItem={toggleItem}
            selectedItems={selectedItems}
            relativeStyle={true}
          />
        )}
        {/* <SelectedItemsSummery selectedItems={selectedItems} title={t(title)} handleRemoveAll={handleRemoveAll} /> */}
      </div>
    </SelectContainer>
  );
};

export default Select;
